module.exports = __webpack_public_path__ + "media/images/login/venuTRAX_black-e546003d4762abb526c89ef1e1229322.png";